import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ID_PARAM, PATH_SEPARATOR } from "@shared/constants/route-variables.constants";
import { NOUS_CONTACTER, STORED_DOCUMENTS } from "@shared/constants/route.constants";
import { ClaimsRedirectValues } from "@shared/enums/claims-redirect-values";
import { ClaimsType } from "@shared/enums/claims.type";
import { PackagesType } from "@shared/enums/packages-type";
import { Claims, ClaimsTypeService } from "@shared/services/claims-type.service";
import { Guid } from "guid-typescript";
import { ButtonModule } from "primeng/button";
import { SkeletonModule } from "primeng/skeleton";
import { ClaimsButtonMRHComponent } from "./claims-buttons/claims-button.component";

@Component({
  selector: "app-service-offerings-mrh",
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule, ButtonModule, ClaimsButtonMRHComponent, SkeletonModule],
  templateUrl: "./service-offerings-mrh.component.html",
})
export class ServiceOfferingsMrhComponent implements OnInit {
  @Input({ required: true }) policyId!: Guid;
  @Input({ required: true }) policyReference!: string;
  @Input({ required: true }) productCode!: string;
  @Input() hasLegalJr = false;
  @Input() isGdaAllowed = false;
  @Input() hasOptionPj = false;
  @Input() isPolicyActive = false;
  ClaimsRedirectValues = ClaimsRedirectValues;
  ClaimsType = ClaimsType;
  isLoading = false;
  claims: Claims[] = [];

  loading = true;

  constructor(
    private readonly claimTypeService: ClaimsTypeService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.claims = this.claimTypeService.getClaims();

    if (
      this.productCode === PackagesType.Grenobloise ||
      this.productCode === PackagesType.Cristolienne ||
      this.productCode === PackagesType.Etudiante
    ) {
      this.claims = this.claims.filter(claim => claim.claimsType === ClaimsType.ALTIMA);
    } else {
      this.claims = this.claims.filter(claim => claim.claimsType !== ClaimsType.ALTIMA);
    }

    if (!this.hasLegalJr) {
      this.claims = this.claims.filter(
        claim => claim.claimsType !== ClaimsType.SFPJ && claim.claimsType !== ClaimsType.RMA
      );
    } else if (this.productCode !== PackagesType.Confort && this.productCode !== PackagesType.ConfortPlus) {
      this.claims = this.claims.filter(
        claim =>
          claim.claimsRedirectValue !== ClaimsRedirectValues.SFPJContracts &&
          claim.claimsType !== ClaimsType.RMA &&
          claim.claimsType !== ClaimsType.SFPJ
      );

      if (this.hasOptionPj) {
        // We don't show SFPJContracts if we have the option PJ
        this.claims.push(
          ...this.claimTypeService
            .getClaims()
            .filter(
              claim =>
                claim.claimsType === ClaimsType.SFPJ && claim.claimsRedirectValue !== ClaimsRedirectValues.SFPJContracts
            )
        );
      }
    }

    this.isLoading = false;
  }

  public get storedDocumentsPath(): string {
    return PATH_SEPARATOR + STORED_DOCUMENTS.replace(ID_PARAM, this.policyId.toString());
  }

  redirectToContactUs() {
    const policyId = this.policyId;
    this.router.navigate([NOUS_CONTACTER], { queryParams: { policyId } });
  }
}
